import { PapiDeviation } from '@wix/da-papi-types';
import { AppState } from '../../types/store';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { getModuleDataByModuleType as getModuleDataByModuleTypeNewGrusers } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';

import { getModuleDataByModuleType } from './modules';
import { ModuleType } from '../../types/modules';
import { getProfileGruser } from './users';

export const getCoverDeviation = (
  state: AppState
): PapiDeviation | undefined => {
  const deviation_gruser = flagEnabled(state, 'deviation_gruser');
  if (deviation_gruser) {
    return getCoverDeviationNewGrusers(state);
  }
  const coverDeviation = (
    getModuleDataByModuleType(state, ModuleType.COVER_DEVIATION) || {}
  ).coverDeviation;
  return coverDeviation;
};

export const getCoverDeviationNewGrusers = (
  state: AppState
): PapiDeviation | undefined => {
  const coverDeviation = (
    getModuleDataByModuleTypeNewGrusers(
      state as any,
      getProfileGruser(state),
      'coverDeviation'
    ) || {}
  ).coverDeviation?.coverDeviation;

  return coverDeviation || undefined;
};

export const getCoverDeviationOffsetY = (state: AppState): number => {
  const coverDeviationidOffsetY =
    (getModuleDataByModuleType(state, ModuleType.COVER_DEVIATION) || {})
      .coverDeviationidOffsetY || 0;
  return coverDeviationidOffsetY;
};

export const getDeviationFileSrc = (
  deviation: PapiDeviation,
  fileType: string
) => {
  const deviationFile = MediaService.getDeviationFile(deviation, fileType);
  return (deviationFile && deviationFile.src) || '';
};
